import { Fragment, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { APIError } from "../../../../core/utils";
import { APP_URLS } from "../../../../api/url";
import API from "../../../../api/axios";
import styled from "styled-components";
import { ThreeDots } from "react-loader-spinner";
import moment from "moment";
import JSONModal from "../../../../assets/SharedComponents/JSONModal/JSONModal";
import NoRecord from "../../../../assets/SharedComponents/Table/NoRecord";
import Pagination from "../../../../assets/SharedComponents/Pagination";
import ViewIcon from "../../../../assets/Images/icons/svgIcon/eye2.svg";
import faHide from "../../../../assets/Images/icons/svgIcon/FaHide.svg"


const countries = JSON.parse(localStorage.getItem("countries")) || [];

const Flagged = ({ userId }) => {

    const [history, _history] = useState([]);
    const [loading, _loading] = useState(false);

    const [totalPage, _totalPage] = useState(0);
    const [page, setPage] = useState(1);

    const [flagLabel, _flagLabels] = useState({})

    const [textRow, _textRow] = useState({
        id: null,
        type: null,
        text: null,
    })


    useEffect(() => {
        const getHistory = async () => {
            _loading(true);
            try {
                const res = await API.get(
                    `${APP_URLS.LIST_FLAGGED_USERS}/${userId}/flags?only_flagged=true&page=${page}`
                );
                const { data: resp } = res;
                if (resp.success) {
                    _history(resp?.data?.data ?? []);
                    _totalPage(resp?.data?.last_page ?? 1);
                } else {
                    toast.error(resp.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            } catch (error) {
                let error_message = APIError(error);
                toast.error(error_message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            } finally {
                _loading(false);
            }
        };
        getHistory();
    }, [page, userId]);

    // Fetch Flag labels
    useEffect(() => {
        if (flagLabel && Object.keys(flagLabel).length > 0) return

        (async () => {
            try {
                const res = await API.get(
                    `${APP_URLS.FRAUD_SETTINGS}/labels`
                );
                const { data: resp } = res;
                if (resp.success) {
                    _flagLabels(resp?.data?.items ?? {})
                } else {
                    toast.error(resp.message, {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                }
            } catch (error) {
                let error_message = APIError(error);
                toast.error(error_message, {
                    position: toast.POSITION.TOP_RIGHT,
                });
            }
        })()

    }, [])

    const handleClick = (report) => {
        if (report?.metadata?.ad_vehicle_id) {
            window.open(
                `${process.env.REACT_APP_FRONTOFFICE_URL_HTTPS}/fr/public-ads/${report.metadata.ad_vehicle_id}`,
                "_blank"
            );
            return;
        }
        if (report?.metadata?.chat_id) {
            window.open(`/chats-messages/${report.metadata.chat_id}`, "_blank");
        }
    };

    const handleDrop = (id, type, text) => {
        if (id === textRow.id && type === textRow.type) {
            _textRow({
                id: null,
                type: null,
                text: null,
            })
            return
        }
        _textRow({
            id: id,
            type: type,
            text: text
        })
    }

    return (
        <Wrapper>
            <div className="tableContainer">
                <table className="modalTable">
                    <thead className="tableHead">
                        <tr className="table-row">
                            <th>Visitor ID</th>
                            <th>
                                FPJS IP <br />
                                User IP
                            </th>
                            <th>Created At</th>
                            <th>Address</th>
                            <th>
                                Flag Reason <br />
                                Flag Points
                            </th>
                            <th>Keywords</th>
                            <th>User Input</th>
                            <th>
                                Browser details
                                <br />
                                Fp Request Data
                                <br />
                                View Model
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        {loading ? (
                            <div className="three-dot">
                                <ThreeDots
                                    height="80"
                                    width="80"
                                    radius="9"
                                    color="#637df4"
                                    ariaLabel="three-dots-loading"
                                    visible={true}
                                />
                            </div>
                        ) : history && history.length > 0 ? (
                            history.map((report, index) => {
                                const country = countries.find(
                                    (o) => o.id === report.country_id
                                );
                                const isClickable =
                                    report?.metadata?.ad_vehicle_id ??
                                    report?.metadata?.chat_id;

                                return (
                                    <Fragment key={`history-${report.id}-${index}`}>
                                        <tr
                                            className={`${report.deleted_at ? "deletedRow" : ""
                                                } table-row`}
                                        >
                                            <td>{report?.visitor_id ?? "-"}</td>
                                            <td>
                                                {report?.ip_address ?? "-"} <br />
                                                {report?.user_ip_address ?? "-"}
                                            </td>
                                            <td>
                                                {moment(report.created_at)
                                                    .tz("Europe/Amsterdam")
                                                    .format("DD-MM-YYYY HH:mm")}
                                            </td>
                                            <td>
                                                {[
                                                    report?.city,
                                                    report?.subdivisions,
                                                    report?.postal_code,
                                                    country?.custom_name,
                                                ]
                                                    .filter(Boolean)
                                                    .join(", ")}
                                            </td>
                                            <td>
                                                {report?.fraud_flags_id ? flagLabel[report.fraud_flags_id] : "-"}
                                                <br />
                                                <br />
                                                <b>{report?.risk_points ? `+${report.risk_points}` : 0}</b>
                                            </td>
                                            <td>
                                                {report?.flagged_keywords && report?.flagged_keywords.length > 0 ?
                                                    report.flagged_keywords.join(", ") :
                                                    "-"
                                                }
                                            </td>
                                            <td>
                                                {report?.metadata?.value ?
                                                    <>
                                                        <span>{(report.metadata.value).slice(0, 15)}...</span>
                                                        <img
                                                            src={faHide}
                                                            alt="show"
                                                            className={`${textRow.id === report.id && textRow.type == "userInput" ? "close" : "open"} dropdownButton`}
                                                            onClick={() => handleDrop(report.id, "userInput", report.metadata.value)}
                                                        />
                                                    </>
                                                    : "-"
                                                }
                                            </td>
                                            <td>
                                                <JSONModal
                                                    buttonText="Show browser details"
                                                    modalHeader="Browser Details"
                                                    jsonData={report?.browser_details}
                                                />
                                                <br />
                                                <JSONModal
                                                    buttonText="Show FP request data"
                                                    modalHeader="Fingerprint Request Data"
                                                    jsonData={report?.fp_request_data}
                                                />
                                                <br />
                                                {isClickable ? (
                                                    <img
                                                        src={ViewIcon}
                                                        className="viewIcon"
                                                        onClick={() => handleClick(report)}
                                                        alt="view"
                                                        title={report?.metadata?.ad_vehicle_id ? 'View Ad Vehicle' : 'View Chat Messages'}
                                                    />
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                        </tr>
                                        {
                                            textRow.text && textRow.id === report.id && <tr className="table-row">
                                                <td className="text-details">{textRow.text}</td>
                                            </tr>
                                        }
                                    </Fragment>
                                );
                            })
                        ) : (
                            <NoRecord />
                        )}
                    </tbody>
                </table>
            </div>

            {totalPage > 1 && (
                <Pagination
                    totalPages={totalPage}
                    page={page}
                    key={totalPage}
                    onPageClick={(page) => setPage(page + 1)}
                />
            )}
        </Wrapper>
    );
};

export default Flagged;

const Wrapper = styled.div`
  .three-dot {
    width: 100%;
    position: static;
    height: 300px;
    display: flex;
    justify-content: center;
    padding: 40px 0
  }
  .tableContainer {
    width: 100%;
  }
  .modalTable {
    height: auto;
    overflow: auto;
    min-width: 100%;
    width: auto;
    margin-top: 10px;
  }
  .auctionTable {
    width: 100%;
  }
  tbody {
    display: block;
    margin-top: 20px;
  }
  .tableHead {
    display: flex;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.6);
    border-radius: 10px;
  }
  .table-row {
    display: flex;
    justify-content: space-between;
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-bottom: 0;
    border-radius: 10px;
    border-radius: 0;
  }
  .table-row:last-child {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
  .table-row:first-child {
    margin-top: 0px;
  }
  .table-row th,
  .table-row td {
    width: 20%;
    padding: 15px 5px;
    display: block;
    justify-content: center;
    align-self: center;
    text-align: center;
    word-break: break-word;
  }
  .viewIcon{
    height: 30px;
    width: 30px;
    cursor: pointer;
  }
    .dropdownButton{
    cursor: pointer;
    margin-left: 5px;
  }
  .open{
    transform: rotate(-90deg);
    -webkit-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
  }
  .close{
    transform: rotate(90deg);
    -webkit-transition: all 0.35s ease-in-out;
    transition: all 0.35s ease-in-out;
  }
    .text-details{
        width: 100% !important;
        text-align: left !important;
    }
`;
